<template>
    <div class="vue-occasion-dropdown-range-filter">
        <div class="min-select select-item">
            <v-select
                v-model="minValue"
                :options="optionsMin"
                :placeholder="placeholder"
                @input="handleInput"
                :disabled="!show"
            >
                <template #selected-option="option">
                    {{ prefix }}{{ option.label }}{{ suffix }}
                </template>

                <template v-slot:option="option">
                    {{ prefix }}{{ option.label }}{{ suffix }}
                </template>
            </v-select>
        </div>
        <div class="max-select select-item">
            <v-select
                v-model="maxValue"
                :options="optionsMax"
                :placeholder="toText"
                @input="handleInput"
                :disabled="!show"
            >
                <template #selected-option="option">
                    {{ prefix }}{{ option.label }}{{ suffix }}
                </template>

                <template v-slot:option="option">
                    {{ prefix }}{{ option.label }}{{ suffix }}
                </template>
            </v-select>
        </div>

        <template v-if="show === false">
            <div>
                <p><small>{{ filterResultsText }}</small></p>
            </div>
        </template>
    </div>
</template>

<script>
import baseFilter from '../mixins/baseFilter';
import translationsMixin from '../../../../../themes/custom/ef2_custom/js/vue/mixins/translations.js'

export default {
    name: "OccasionDropdownRangeFilter",

    mixins: [baseFilter, translationsMixin],

    props: {
        min: {
            type: Number,
            required: true,
        },
        max: {
            type: Number,
            required: true,
        },
        step: {
            type: Number,
            default: 5000,
        },
        placeholder: {
            type: String,
            default: 'van',
        },
        reverseRange: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
         },
        suffix: {
            type: String
        }
    },

    data() {
        return {
            minValue: null,
            maxValue: null,
        }
    },

    computed: {
        show() {
            return ! _.isEqual(this.min, this.max);
        },

        optionsMin() {
            if (this.reverseRange) {
                if (!lodash.isNil(this.maxValue)) {
                    return lodash.rangeRight(this.roundDownToNearestThousand(this.min), this.roundUpToNearestThousand(this.maxValue + 1, false), this.step);
                }

                return lodash.rangeRight(this.roundDownToNearestThousand(this.min), this.roundUpToNearestThousand(this.max + 1, false), this.step);
            }

            if (!lodash.isNil(this.maxValue)) {
                return _.range(this.roundDownToNearestThousand(this.min), this.roundUpToNearestThousand(this.maxValue + 1, false), this.step);
            }

            return _.range(this.roundDownToNearestThousand(this.min), this.roundUpToNearestThousand(this.max + 1, false), this.step);
        },

        optionsMax() {
            if (this.reverseRange) {
                if (!lodash.isNil(this.minValue)) {
                    return lodash.rangeRight(this.roundDownToNearestThousand(this.minValue), this.roundUpToNearestThousand(this.max + 1), this.step);
                }

                return lodash.rangeRight(this.roundDownToNearestThousand(this.min), this.roundUpToNearestThousand(this.max + 1), this.step);
            }

            if (!lodash.isNil(this.minValue)) {
                return _.range(this.roundDownToNearestThousand(this.minValue), this.roundUpToNearestThousand(this.max + 1), this.step);
            }

            return _.range(this.roundDownToNearestThousand(this.min), this.roundUpToNearestThousand(this.max + 1), this.step);
        },
    },

    created() {
        this.checkLocalStorageValue();
    },

    mounted() {
        this.eventBus.$on('reset-filters', () => {
            this.minValue = null;
            this.maxValue = null;
        });
    },

    methods: {
        handleInput() {
            let min = this.minValue;
            let max = this.maxValue;

            if (lodash.isNil(this.minValue) && lodash.isNil(this.maxValue)) {
                min = this.min;
                max = this.max;
            }

            if (lodash.isNil(this.minValue) && !lodash.isNil(this.maxValue)) {
                min = this.min;
            }

            if (!lodash.isNil(this.minValue) && lodash.isNil(this.maxValue)) {
                max = this.max;
            }

            this.eventBus.$emit('range-filter-changed', {
                filterKey: this.filterKey,
                min: min,
                max: max,
                type: 'range'
            });
        },

        roundDownToNearestThousand(value) {
            if (_.isEqual(value, 0) || _.isEqual(this.filterKey, 'field_bouwjaar')) {
                return value;
            }

            let calculatedValue = Math.round((value - this.step) / this.step) * this.step;

            if (calculatedValue === -0 || calculatedValue < 0) {
                return 0;
            }

            return calculatedValue;
        },

        roundUpToNearestThousand(value, multiply = true) {
            if (_.isEqual(this.filterKey, 'field_bouwjaar')) {
                return value;
            }

            let calculatedValue = Math.round((value + this.step) / this.step) * this.step;

            if (calculatedValue === -0 || calculatedValue < 0) {
                return 0;
            }

            if (multiply) {
                return calculatedValue + this.step;
            }

            return calculatedValue;
        },

        checkLocalStorageValue() {
            let localStorageFilters = localStorage.getItem('appliedFilters');

            if (lodash.isNil(localStorageFilters)) {
                return;
            }

            localStorageFilters = JSON.parse(localStorage.getItem('appliedFilters'));

            if (lodash.isNil(localStorageFilters) || _.isEmpty(localStorageFilters)) {
                return;
            }

            let localStorageEntry = _.find(localStorageFilters, {'key': this.filterKey});

            if (lodash.isNil(localStorageEntry) || lodash.isNil(localStorageEntry.min) || lodash.isNil(localStorageEntry.max) || _.isEmpty(localStorageEntry)) {
                return;
            }

            if (_.isEqual(localStorageEntry.min, this.min) && _.isEqual(localStorageEntry.max, this.max)) {
                return;
            }

            if (!_.isEqual(localStorageEntry.min, this.min) && _.isEqual(localStorageEntry.max, this.max)) {
                this.minValue = localStorageEntry.min;
                return;
            }

            if (_.isEqual(localStorageEntry.min, this.min) && !_.isEqual(localStorageEntry.max, this.max)) {
                this.maxValue = localStorageEntry.max;
                return;
            }

            this.minValue = localStorageEntry.min;
            this.maxValue = localStorageEntry.max;
        }
    }
}
</script>